import React, { useEffect, useState, useMemo } from "react";
import NoDataFound from "../common/NoDataFound";
import LeagueTableW from "../common/table/LeagueTableW";
import TableGroup from "../common/table/TableGroup";
import { loadStyles } from "../../utils/cssLoader";

const RugbyTable = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  sport,
  websiteBaseUrl,
  dataPath
}) => {
  const [clientData, setClientData] = useState(null);

  const data = useMemo(() => (dataClient ? clientData : ServerData), [clientData, ServerData, dataClient]);

  useEffect(() => {
    if (!dataClient) return;

    try {
      const raw = document?.querySelector(".microservice-cont")?.getAttribute("data-listingdata");
      if (!raw) return;

      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed ?? null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("rugby");
    }
  }, [loadCSS]);


  const hasTable = data?.table?.length > 0;
  const hasGroups = data?.groups?.length > 0;

  return (
    <>
      {title && <h1>{title}</h1>}

      {hasTable ? (
        <div className="global_table standing_table">
          <LeagueTableW table={data.table} teams={data.teams} sport={sport} websiteBaseUrl={websiteBaseUrl} dataClient={dataClient} dataPath={dataPath} />
        </div>
      ) : (
        <NoDataFound />
      )}

      {hasGroups && <TableGroup groups={data.groups} />}
    </>
  );
};

export default RugbyTable;
